export default "__VITE_ASSET__iAgl5_2i__"